import { notifyApiSuccess } from "@/v2/notifications/notify";

export function marketGroupId(values: Record<string, unknown>): string | number {
  return values.id as string | number;
}

export function notifySuccess(): void {
  notifyApiSuccess("Successfully updated.");
}
